<template>
    <div :class="{ 'vue-lightbox' : !resetstyles }">
        <h1 v-if="title">{{ title }}</h1>
        <ul>
            <li v-for="(image, index) in images" @click="clickImage(index)">

                    <slot :image="image"></slot>
            </li>
        </ul>
        <div class="lightbox-overlay" v-if="overlayActive" @click.self="closeOverlay">
            <div class="holder">
                <img :src="images[currentImage].src"/>
                <div class="nav">
                    <a class="close" nohref @click="closeOverlay"><span class="close-item">&times;</span></a>
                    <a  v-if="nav" class="prev" nohref @click="prevImage"><span>&#8592;</span></a>
                    <a  v-if="nav" class="next" nohref @click="nextImage"><span>&#8594;</span></a>
                </div>
                <p v-if="caption && images[currentImage].caption">{{ images[currentImage].caption }}</p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            resetstyles: {
                default: false,
                type: Boolean,
            },
            title: {
                type: String,
            },
            images: {
                type: Array,
            },
            loop: {
                default: true,
                type: Boolean,
            },
            nav: {
                default: true,
                type: Boolean,
            },
            caption: {
                deftault: true,
                type: Boolean,
            },
        },
        data() {
            return {
                currentImage: null,
                overlayActive: false,
            };
        },
        mounted() {
            const self = this;
            window.addEventListener('keydown', (e) => {
                self.handleGlobalKeyDown(e);
            });
        },
        methods: {
            clickImage(index) {
                if(this.images[index].src){
                    this.currentImage = index;
                    this.overlayActive = true;
                }
            },
            nextImage() {
                if (this.currentImage === (this.images.length - 1)) {
                    if (this.loop) {
                        this.currentImage = 0;
                    }
                } else {
                    this.currentImage += 1;
                }
            },
            prevImage() {
                if (this.currentImage === 0) {
                    if (this.loop) {
                        this.currentImage = (this.images.length - 1);
                    }
                } else {
                    this.currentImage -= 1;
                }
            },
            closeOverlay() {
                this.overlayActive = false;
            },
            handleGlobalKeyDown(e) {
                switch (e.keyCode) {
                    case 37: this.prevImage(); break;
                    case 39: this.nextImage(); break;
                    case 27: this.closeOverlay(); break;
                    default: break;
                }
            },
        },
    };
</script>

<style lang="scss">@import "@/assets/scss/components/_lightbox.scss";</style>